export default __webpack_public_path__ + "static/media/23.48db5750.jpeg";